import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_r5aqp735w9: FaireBrandEntity = {
  token: "b_r5aqp735w9",
  type: "brand",
  name: "Jewelry Max",
  avatarUrl:
    "https://cdn.faire.com/fastly/096b1193ca747ee710a358980ef43abea2950d6828b5668746eb5c82f9bc65a5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6a373e35f7c7673c70483a4b04f67cf27b834eed81c0b17130bd27f5cbf382de.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/096b1193ca747ee710a358980ef43abea2950d6828b5668746eb5c82f9bc65a5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6a373e35f7c7673c70483a4b04f67cf27b834eed81c0b17130bd27f5cbf382de.jpeg",
  location: "Brea, CA, USA",
  minimumOrderDollars: 97,
  rating: 4.8,
  reviewCount: 113,
  isInsider: true,
  description:
    "Jewelrymax is your premier destination for wholesale jewelry! We are thrilled to have you here, and we invite you to explore our stunning collection of exquisite jewelry that embodies elegance, quality, and style. Whether you're a seasoned jewelry retailer or a newcomer to the world of wholesale jewelry. Jewelrymax is designed to cater to all your needs.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:55.350Z",
    importedBy: "entity-db-cli",
  },
};
